import { axiosNTL, axiosNL, axiosNT } from '../../../services/axios';

const getRelevantExams = () =>
    axiosNTL
    .get('/course/getAvailableCourseListing')
    .then((res: any) => {
        const relevantExams: any[] = res.responseObject;
        return Promise.resolve(relevantExams);
    })

const getStudentDetails = () => axiosNTL.get('/user/student-user/details').then((res: any) => {
    const studentDetails = res.responseObject;
    return Promise.resolve(studentDetails);
})
const relevantExamsService = {
    getRelevantExams,
    getStudentDetails
}

export default relevantExamsService;